export default __webpack_public_path__ + "static/media/shocks.e1cc1796.svg";